import type { AlertProps as SystemAlertProps } from '@hover/blueprint';
import { Alert as SystemAlert } from '@hover/blueprint';
import React from 'react';

type AlertColor = 'success' | 'danger' | 'warning';
type AlertStatus = SystemAlertProps['status'];

interface AlertProps extends Omit<SystemAlertProps, 'color'> {
  color?: AlertColor;
}

const statusMap: { [key in AlertColor]: AlertStatus } = {
  success: 'success',
  danger: 'error',
  warning: 'warning',
};

const Alert = ({
  children,
  color,
  status,
  size = 'small',
  ...props
}: AlertProps) => (
  <SystemAlert
    size={size}
    status={status ?? (color ? statusMap[color] : 'error')}
    {...props}
  >
    {children}
  </SystemAlert>
);

export { Alert };
